module.exports = __webpack_public_path__ + "img/ChevronLeft.3f444fad.svg";